import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-11934f75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "footer-content" }
const _hoisted_3 = { class: "footer-link-categories" }
const _hoisted_4 = { class: "link-categorie" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Vad letar du efter?", -1))
const _hoisted_6 = { class: "link-categorie" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Följ oss", -1))
const _hoisted_8 = { class: "follow-icon-wrapper" }
const _hoisted_9 = {
  class: "socials-link",
  href: "https://m.facebook.com/people/T%C3%A5gluffa-i-Europa/100070865675661/",
  target: "_blank"
}
const _hoisted_10 = {
  class: "socials-link",
  href: "https://www.tiktok.com/@tagluffa.i.europa",
  target: "_blank"
}
const _hoisted_11 = {
  class: "socials-link",
  href: "https://www.instagram.com/tagluffaieuropa",
  target: "_blank"
}
const _hoisted_12 = { class: "link-categorie" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Om Tågluffa i Europa", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divider" }, null, -1))
const _hoisted_15 = { class: "logo-wrapper" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "details" }, "© Tågluffa i Europa", -1))


import tagluffaieuropa_logo from "@/assets/SVG/tagluffaieuropa_logo.vue";
import interrail_logo from "@/assets/SVG/interrail_logo.vue";
import facebookIcon from "@/assets/SVG/facebookIcon.vue";
import tiktokIcon from "@/assets/SVG/tiktokIcon.vue";
import instagramIcon from "@/assets/SVG/instagramIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'SiteFooter',
  props: {
	show: {
		type: Boolean,
		default: true,
	},
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/biljetter/biljettval"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Boka biljetter")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/interrailkort"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Interrailkort")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/guider"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Guider ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/artiklar"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Artiklar")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/support"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Support")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _createVNode(facebookIcon, { class: "socials-icon" })
            ]),
            _createElementVNode("a", _hoisted_10, [
              _createVNode(tiktokIcon, { class: "socials-icon" })
            ]),
            _createElementVNode("a", _hoisted_11, [
              _createVNode(instagramIcon, { class: "socials-icon" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_router_link, {
            class: "footer-link",
            to: "/villkor"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Våra villkor")
            ]),
            _: 1
          })
        ])
      ]),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createVNode(tagluffaieuropa_logo),
        _createVNode(interrail_logo)
      ]),
      _hoisted_16
    ])
  ]))
}
}

})